// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/stakeholders/firstparty/v1/get_stakeholder.proto

/* eslint-disable */
import { ApiStakeholder } from "./stakeholder";

/** Request message for retrieving a stakeholder */
export interface ApiGetStakeholderRequest {
  /** The ID of the stakeholder to retrieve */
  readonly id: string;
}

/** Response message for retrieving a stakeholder */
export interface ApiGetStakeholderResponse {
  /** The requested stakeholder */
  readonly stakeholder: ApiStakeholder | null;
}

/** Error codes for GetStakeholder operation */
export interface ApiGetStakeholderErrors {
}

/** Not found error codes */
export const ApiGetStakeholderErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED - Stakeholder not found or unauthorized */
  NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED: "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED",
} as const;

export type ApiGetStakeholderErrorsNotFoundError =
  typeof ApiGetStakeholderErrorsNotFoundError[keyof typeof ApiGetStakeholderErrorsNotFoundError];

export namespace ApiGetStakeholderErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiGetStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED =
    typeof ApiGetStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
}

export function apiGetStakeholderErrorsNotFoundErrorFromJSON(object: any): ApiGetStakeholderErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiGetStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED":
      return ApiGetStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
    default:
      return ApiGetStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiGetStakeholderErrorsNotFoundErrorToJSON(object: ApiGetStakeholderErrorsNotFoundError): string {
  switch (object) {
    case ApiGetStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiGetStakeholderErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED:
      return "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

export const ApiGetStakeholderRequest: MessageFns<ApiGetStakeholderRequest> = {
  fromJSON(object: any): ApiGetStakeholderRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiGetStakeholderRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiGetStakeholderResponse: MessageFns<ApiGetStakeholderResponse> = {
  fromJSON(object: any): ApiGetStakeholderResponse {
    return { stakeholder: isSet(object.stakeholder) ? ApiStakeholder.fromJSON(object.stakeholder) : null };
  },

  toJSON(message: ApiGetStakeholderResponse): unknown {
    const obj: any = {};
    if (message.stakeholder !== undefined && message.stakeholder !== null) {
      obj.stakeholder = ApiStakeholder.toJSON(message.stakeholder);
    }
    return obj;
  },
};

export const ApiGetStakeholderErrors: MessageFns<ApiGetStakeholderErrors> = {
  fromJSON(_: any): ApiGetStakeholderErrors {
    return {};
  },

  toJSON(_: ApiGetStakeholderErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
